module.exports = __webpack_public_path__ + "img/ICRT_Logo_Long_White.c2105db5.png";